module.exports = __webpack_public_path__ + "img/orange_060.e97cbd40.png";